import { AVAILABILITY_MODE } from '../constants'
import {
  cascadingRecallAllowed,
  hasSelectableVisits,
} from '../hooks/anchorConstraints'
import { REPEAT_MODE } from '../constants/repeatTypes'

/** Requires a repeating cadence so a "next instance" can exist. */
export const untilNextInstanceOpensAllowed = schedule => {
  const repeatMode = schedule?.repeat?.mode || REPEAT_MODE.doesNotRepeat
  return repeatMode !== REPEAT_MODE.doesNotRepeat
}

const localTimeToMinutes = value => {
  if (!value || typeof value !== 'string') return null
  const match = value.trim().match(/^(\d{1,2}):(\d{2})$/)
  if (!match) return null
  const hours = Number(match[1])
  const minutes = Number(match[2])
  if (Number.isNaN(hours) || Number.isNaN(minutes) || hours > 23 || minutes > 59) return null
  return hours * 60 + minutes
}

export const validateAvailability = (schedule, scheduleIndex, entityLookup = {}) => {
  const errors = {}
  const availability = schedule?.availability || {}
  const prefix = `schedules.${scheduleIndex}.availability`
  if (!availability.mode) {
    errors[`${prefix}.mode`] = 'Select when this instrument is available.'
  }
  if (availability.mode === AVAILABILITY_MODE.fixedDuration) {
    const value = availability.openFor?.value
    if (value === '' || value == null || Number(value) <= 0) {
      errors[`${prefix}.openFor`] = 'Enter how long the instrument stays open.'
    }
  }
  if (availability.mode === AVAILABILITY_MODE.withdrawIfAnchoringVisitMissed && !cascadingRecallAllowed(schedule.anchors)) {
    errors[`${prefix}.mode`] = 'Withdraw if the anchoring visit is missed requires a Visit or Visit Cycle anchor.'
  }
  if (availability.mode === AVAILABILITY_MODE.untilAnchoringVisitCompleted) {
    if (!hasSelectableVisits(entityLookup)) {
      errors[`${prefix}.mode`] =
        'Until the anchoring visit is completed requires at least one visit configured in the study.'
    } else if (!cascadingRecallAllowed(schedule.anchors)) {
      errors[`${prefix}.mode`] =
        'Until the anchoring visit is completed requires a Visit or Visit Cycle anchor.'
    }
  }
  if (
    availability.mode === AVAILABILITY_MODE.untilNextInstanceOpens &&
    !untilNextInstanceOpensAllowed(schedule)
  ) {
    errors[`${prefix}.mode`] =
      'Until the next instance opens requires a repeat schedule other than Doesn\'t repeat.'
  }
  if (availability.dailyWindow?.enabled) {
    if (!availability.dailyWindow.from || !availability.dailyWindow.until) {
      errors[`${prefix}.dailyWindow`] = 'Enter a daily window start and end time.'
    } else if (availability.mode === AVAILABILITY_MODE.sameDayOnly) {
      const fromMinutes = localTimeToMinutes(availability.dailyWindow.from)
      const untilMinutes = localTimeToMinutes(availability.dailyWindow.until)
      if (
        fromMinutes != null &&
        untilMinutes != null &&
        untilMinutes <= fromMinutes
      ) {
        errors[`${prefix}.dailyWindow`] = 'End time must be later than start time for the same day.'
      }
    }
  }
  return errors
}
